<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>催收员监控</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="search" style="margin-left:16px;">
                <div class="searchleft">
                    <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                        <el-form-item label="监控时间">
                            <el-date-picker
                                v-model="searchform.time"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item :label="$t('groupName')">
                            <el-select size="small" v-model="searchform.groupId" style="width:180px;" :placeholder="$t('qxzrole')"  >
                                <el-option :label="$t('buxian')" :value="0"></el-option>
                                <el-option v-for="(item,index) in grouplist" :label="item.groupName" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item>
                            <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <el-table :data="list" @current-change="handleCurrentChange" 
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 200px; height:470px;">
                        <el-table-column prop="nickName" label="名称"></el-table-column>
                    </el-table>
                    <div class="page">
                        <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                    </div>
                </div>
                <div class="listleft">
                    <el-tabs type="border-card">
                        <div>{{monName}}</div>
                        <div class="orderdiv" style="margin-top: 8px;">
                            <div id="container" class="formbox" style="width:100%;height:380px;">
                            </div>
                        </div>
                    </el-tabs>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import * as echarts from 'echarts';
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    id: null,
                    phone: null,
                    mchOrderNo: null,
                    userName: null,
                    createTime: null,
                    exclusiveLinks:null,
                    stats: null,
                    idCardPositive:null,
                },
                checkForm: {
                    userId: null,
                    va1: null,
                },
                searchform: {
                    time: "",
                },
                loading: false,
                showadd: false,
                list: [],
                value1:[],
                total: 1,
                pageNo: 1,
                pageSize: 10,
                user:null,
                myChart: null,
                monName:null,
                grouplist:[],
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.searchform.time = this.getNowTime()
            this.getList()
            this.getgrouplist()

            // 首次渲染也加载图表
            this.$nextTick(() => {
                this.getDetail();
            });
        },
        methods: {
            getNowTime() {
                const time = new Date(Date.now()).toISOString().split('T')[0];
                return time
            },

            handleCurrentChange(val) {
                //+ " 时间节点：" + this.searchform.time
                this.currentRow = val.id;
                this.monName = "监控员工：" + val.nickName;
                this.getDetail();
            },

            getgrouplist(){
                _api.get(apiurl.groupAll, {
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.grouplist = res.data
                })
            },

            getList() {
                this.loading = true
                _api.get(apiurl.users, {
                    page: this.pageNo,
                    size: this.pageSize,
                    groupId: this.searchform.groupId,
                    roleId: 3,
                    enabled: 1,
                }).then(res => {
                    this.loading = false
                    this.list = res.content
                    this.total = res.totalElements
                })
            },
           
            getDetail() {
                if (this.searchform.time == null) {
                    alert("监控时间不能为空");
                    return
                }
                let xData = [];
                let yData = [];
                _api.get(apiurl.collmonitor, {
                     userId: this.currentRow,
                     time: this.searchform.time
                }).then(res => {
                    if (res.code === 200) {
                        xData = res.data.xData;
                        yData = res.data.yData;
                    }

                    this.$nextTick(() => {
                        const dom = document.getElementById('container');
                        if (!dom) return;

                        // 避免重复初始化
                        if (!this.myChart) {
                            this.myChart = echarts.init(dom);
                            window.addEventListener('resize', () => {
                                this.myChart.resize();
                            });
                        }

                        const option = {
                            xAxis: {
                                type: 'category',
                                data: xData
                            },
                            yAxis: {
                                type: 'value'
                            },
                            series: [
                                {
                                    data: yData,
                                    type: 'line',
                                    smooth: true,
                                    label: {
                                        show: true,
                                        position: 'top'
                                    }
                                }
                            ]
                        };

                        this.myChart.setOption(option);
                    });
                });
            },

            onSubmit() {
                this.getList()
            },

            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },

            currentchange(data) { //当前页变化
                this.pageNo = data
                this.getList()
            },
        }
    }
</script>
<style scoped>
    
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .orderdiv{
        display: flex;
        border-style: ridge;
        border-bottom: 1px solid #EBEEF5;
    }

    .listleft {
        width: 80%;
        margin-left: 0.5%;
    }

    body .el-table th.gutter{
        display: table-cell!important;
    }

    .listright {
        width: 20%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }
    .formbox{ padding:15px 0; margin-top: 10px;}

    .listrighttop span {
        float: right;
    }
    .toptj{ display: flex; margin:15px 0;}
    .tjitem{ 
        flex: 1; 
        background: #ffffff; 
        cursor: pointer; 
        border: #ebedf0 solid 1px; 
        height: 60px; 
        margin-right: 10px;
        padding: 8px 12px;
        text-align: center;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>